import { useRef } from 'react'

interface ElementMessageSearchBarProps {
  currentSearchQuery: string
  onSearchQueryChange: (updatedSearchQuery: string) => void
  onSearchSubmit: (submittedSearchQuery: string) => void
}

export function ElementMessageSearchBar({
  currentSearchQuery,
  onSearchQueryChange,
  onSearchSubmit
}: ElementMessageSearchBarProps) {
  const searchDebounceTimerRef = useRef<ReturnType<typeof setTimeout> | null>(null)

  function handleSearchInputChange(changeEvent: React.ChangeEvent<HTMLInputElement>): void {
    const updatedSearchQuery = changeEvent.target.value
    onSearchQueryChange(updatedSearchQuery)

    if (searchDebounceTimerRef.current) {
      clearTimeout(searchDebounceTimerRef.current)
    }
    searchDebounceTimerRef.current = setTimeout(() => {
      onSearchSubmit(updatedSearchQuery)
    }, 300)
  }

  function handleSearchKeyDown(keyboardEvent: React.KeyboardEvent<HTMLInputElement>): void {
    if (keyboardEvent.key === 'Enter') {
      if (searchDebounceTimerRef.current) {
        clearTimeout(searchDebounceTimerRef.current)
      }
      onSearchSubmit(currentSearchQuery)
    }
  }

  return (
    <div className="element-search-bar">
      <input
        type="text"
        className="element-search-input"
        placeholder="Search messages..."
        value={currentSearchQuery}
        onChange={handleSearchInputChange}
        onKeyDown={handleSearchKeyDown}
        aria-label="Search messages"
      />
    </div>
  )
}
